// src/Pages/LibraryPage.js

import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChartMixedUpCircleDollar,
  faChartMixedUpCircleCurrency,
  faChartBullet,
  faFileArrowDown,
} from '@fortawesome/pro-regular-svg-icons';
import NavBarHome from '../Layouts/NavBarHome';
import FooterHome from '../Layouts/FooterHome';
import headerBg from '../pagecomponents/screenshots/marketreserach.jpg';

const content = {
  es: {
    headerTitle: 'Análisis del presente, para estrategias de futuro',
    headerSubtitle: 'Informes y publicaciones',
    commitmentTitle: 'Nuestro Compromiso',
    commitmentJSX: (styles) => (
      <>
        <p style={styles.commitmentText}>
          Como líder, tú tienes el{' '}
          <strong style={styles.commitmentStrong}>poder</strong> de{' '}
          <strong style={styles.commitmentStrong}>transformar</strong> la forma
          en que tu organización{' '}
          <strong style={styles.commitmentStrong}>atrae</strong> y{' '}
          <strong style={styles.commitmentStrong}>retiene</strong> a su gente.
          Por eso, como{' '}
          <strong style={styles.commitmentStrong}>
            expertos en desarrollo de talento
          </strong>
          , sentimos que es nuestra{' '}
          <strong style={styles.commitmentStrong}>responsabilidad</strong>{' '}
          compartir contigo de manera abierta y rigurosa los hallazgos de
          nuestros estudios sectoriales. No queremos que esa información se
          quede guardada en un informe: queremos que tú puedas acceder a{' '}
          <strong style={styles.commitmentStrong}>datos reales</strong>,{' '}
          <strong style={styles.commitmentStrong}>conclusiones</strong> y{' '}
          <strong style={styles.commitmentStrong}>buenas prácticas</strong> que
          te ayuden a entender a fondo los factores que impulsan la fidelización
          y el crecimiento de tus equipos.
        </p>
        <p style={styles.commitmentText}>
          Más allá de la solución tecnológica que ofrecemos, nuestra verdadera
          motivación es ayudarte a tomar{' '}
          <strong style={styles.commitmentStrong}>
            decisiones basadas en evidencia
          </strong>{' '}
          (y no sólo en intuiciones). Por eso te facilitamos{' '}
          <strong style={styles.commitmentStrong}>insights claros</strong> sobre
          cómo{' '}
          <strong style={styles.commitmentStrong}>
            desarrollar competencias
          </strong>
          ,{' '}
          <strong style={styles.commitmentStrong}>
            reforzar el compromiso
          </strong>{' '}
          y{' '}
          <strong style={styles.commitmentStrong}>
            diseñar planes de carrera
          </strong>{' '}
          que realmente marquen la diferencia. Con esta información en tus
          manos, tú podrás{' '}
          <strong style={styles.commitmentStrong}>
            liderar con consciencia
          </strong>{' '}
          y{' '}
          <strong style={styles.commitmentStrong}>construir un entorno</strong>{' '}
          donde el talento quiera quedarse y crecer.
        </p>
      </>
    ),
  },
  en: {
    headerTitle: 'Analysis of the Present for Future Strategies',
    headerSubtitle: 'Reports and Publications',
    commitmentTitle: 'Our Commitment',
    commitmentJSX: (styles) => (
      <>
        <p style={styles.commitmentText}>
          As a leader, you have the{' '}
          <strong style={styles.commitmentStrong}>power</strong> to{' '}
          <strong style={styles.commitmentStrong}>transform</strong> how your
          organization <strong style={styles.commitmentStrong}>attracts</strong>{' '}
          and <strong style={styles.commitmentStrong}>retains</strong> its
          people. That’s why, as{' '}
          <strong style={styles.commitmentStrong}>
            talent development experts
          </strong>
          , we feel it’s our{' '}
          <strong style={styles.commitmentStrong}>responsibility</strong> to
          share the findings of our sector studies with you openly and
          rigorously. We don’t want that information to sit hidden in a report:
          we want you to access{' '}
          <strong style={styles.commitmentStrong}>real data</strong>,{' '}
          <strong style={styles.commitmentStrong}>conclusions</strong>, and{' '}
          <strong style={styles.commitmentStrong}>best practices</strong> that
          help you understand the factors driving employee retention and team
          growth.
        </p>
        <p style={styles.commitmentText}>
          Beyond the technological solution we offer, our true motivation is to
          help you make{' '}
          <strong style={styles.commitmentStrong}>data-driven decisions</strong>{' '}
          —not just rely on intuition—. That’s why we provide{' '}
          <strong style={styles.commitmentStrong}>clear insights</strong> on how
          to{' '}
          <strong style={styles.commitmentStrong}>develop competencies</strong>,{' '}
          <strong style={styles.commitmentStrong}>reinforce commitment</strong>,
          and{' '}
          <strong style={styles.commitmentStrong}>design career plans</strong>{' '}
          that truly make a difference. With this information in your hands, you
          can{' '}
          <strong style={styles.commitmentStrong}>lead with awareness</strong>{' '}
          and{' '}
          <strong style={styles.commitmentStrong}>build an environment</strong>{' '}
          where talent wants to stay and grow.
        </p>
      </>
    ),
  },
};

const styles = {
  container: {
    fontFamily: "'Helvetica Neue', Arial, sans-serif",
    margin: 0,
    padding: 0,
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
  },
  header: {
    position: 'relative',
    background: `url(${headerBg}) center/cover no-repeat`,
    height: 350,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    color: '#fff',
  },
  headerOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.4)',
    zIndex: 0,
  },
  headerTitle: {
    fontSize: 42,
    fontWeight: 700,
    margin: 0,
    zIndex: 1,
  },
  headerSubtitle: {
    fontSize: 18,
    margin: '10px 0 0',
    fontWeight: 400,
    zIndex: 1,
  },
  commitmentSection: {
    padding: '80px 20px',
    backgroundColor: '#fff',
    textAlign: 'center',
  },
  commitmentTitle: {
    fontSize: 48,
    fontWeight: 700,
    margin: '0 auto 20px',
    lineHeight: 1.1,
    maxWidth: 800,
  },
  commitmentRed: {
    color: '#ff2300',
  },
  commitmentText: {
    fontSize: 18,
    fontWeight: 400,
    color: '#333',
    lineHeight: 1.7,
    maxWidth: 800,
    margin: '20px auto 0',
    whiteSpace: 'pre-wrap',
    textAlign: 'justify',
  },
  commitmentStrong: {
    color: '#000',
    fontWeight: 700,
  },
  hr: {
    border: 'none',
    height: '2px',
    backgroundColor: '#ff2300',
    margin: '60px 0',
  },
  resourceGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
    gap: 20,
    padding: '50px 20px',
    backgroundColor: '#f9f9f9',
    flex: 1,
  },
  card: {
    backgroundColor: '#fff',
    borderRadius: 20,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    color: '#333',
    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
    padding: 20,
    height: 300,
    justifyContent: 'flex-start',
  },
  cardIcon: {
    fontSize: 48,
    color: 'inherit',
    marginBottom: 12,
    marginTop: 40,
    alignSelf: 'center',
  },
  cardTitle: {
    textAlign: 'center',
    marginBottom: 'auto',
  },
  cardMainTitle: {
    fontSize: 20,
    fontWeight: 700,
    lineHeight: 1.2,
  },
  cardSubtitle: {
    fontSize: 14,
    fontWeight: 400,
    color: '#666',
    marginTop: 4,
  },
  cardButton: {
    padding: '8px 16px',
    borderRadius: 6,
    fontSize: 14,
    fontWeight: 700,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    marginTop: 'auto',
  },
};

function LibraryPage() {
  const [language, setLanguage] = useState(
    () => localStorage.getItem('language') || 'es'
  );
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    localStorage.setItem('language', language);
  }, [language]);

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < 768);
    onResize();
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  const lang = content[language];

  // Ajuste de tamaño de título en móvil para "Nuestro Compromiso"
  const commitmentTitleStyle = {
    ...styles.commitmentTitle,
    fontSize: isMobile ? '32px' : styles.commitmentTitle.fontSize,
  };

  // Colores de acento para borde y botón
  const accentColors = ['#FF2300', '#FF4500', '#FF8C00'];

  // Cards: añadimos href y CTA localizado para Employee Care Report
  const cards = [
    {
      icon: faChartMixedUpCircleDollar,
      title: 'Employee Economic Impact (2025H2)',
    },
    {
      icon: faChartMixedUpCircleCurrency,
      title: 'Employee Care Report (2025H2)',
      href: 'https://49337122.hs-sites.com/es/employee-care-report-2025h2',
      cta: { es: 'Descarga ahora', en: 'Download now' },
    },
    { icon: faChartBullet, title: 'PowerSkills Evolution Report (2025H2)' },
  ];

  return (
    <div style={styles.container}>
      <NavBarHome language={language} />

      {/* Header Hero */}
      <header style={styles.header}>
        <div style={styles.headerOverlay} />
        <h1 style={styles.headerTitle}>{lang.headerTitle}</h1>
        <p style={styles.headerSubtitle}>{lang.headerSubtitle}</p>
      </header>

      {/* Nuestro Compromiso / Our Commitment */}
      <section style={styles.commitmentSection}>
        <h2 style={commitmentTitleStyle}>
          <hr style={styles.hr} />
          {lang.commitmentTitle.split(' ')[0]}{' '}
          <span style={styles.commitmentRed}>
            {lang.commitmentTitle.split(' ')[1]}
          </span>
        </h2>
        {lang.commitmentJSX(styles)}
        <hr style={styles.hr} />
      </section>

      {/* Biblioteca de Recursos: tarjetas estilo Servicios */}
      <main style={styles.resourceGrid}>
        {cards.map(({ icon, title, href, cta }, index) => {
          const color = accentColors[index];
          const match = title.match(/^(.*)\s+(\(.*\))$/);
          const mainText = match ? match[1] : title;
          const subText = match ? match[2] : '';

          return (
            <div
              key={title}
              style={{
                ...styles.card,
                border: `4px solid ${color}`,
              }}
            >
              <FontAwesomeIcon
                icon={icon}
                style={{ ...styles.cardIcon, color }}
              />

              <div style={styles.cardTitle}>
                <div style={styles.cardMainTitle}>{mainText}</div>
                {subText && <div style={styles.cardSubtitle}>{subText}</div>}
              </div>

              {href ? (
                <a
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    ...styles.cardButton,
                    backgroundColor: color,
                    border: 'none',
                    color: '#fff',
                    textDecoration: 'none',
                  }}
                >
                  <FontAwesomeIcon
                    icon={faFileArrowDown}
                    style={{ color: '#fff' }}
                  />
                  {cta?.[language] || 'Download now'}
                </a>
              ) : (
                <button
                  style={{
                    ...styles.cardButton,
                    backgroundColor: color,
                    border: 'none',
                    color: '#fff',
                  }}
                >
                  <FontAwesomeIcon
                    icon={faFileArrowDown}
                    style={{ color: '#fff' }}
                  />
                  Coming Soon
                </button>
              )}
            </div>
          );
        })}
      </main>

      <FooterHome language={language} setLanguage={setLanguage} />
    </div>
  );
}

export default LibraryPage;
